<template>
    <AppCard class="flex flex-col items-center justify-center">
        <slot name="header"></slot>
        <div class="relative w-full">
            <div class="absolute left-0 top-2 w-16" v-if="badge">
                <img class="lazy" :data-src="badge.path" :alt="badge.name" />
            </div>
            <div class="absolute left-0 top-2 w-16" v-else-if="product.badges && product.badges.length">
                <img class="lazy" :data-src="product.badges[0].path" :alt="product.badges[0].name" />
            </div>

            <Link :href="reviewsLink">
                <img class="max-h-28 max-w-fit mx-auto mb-2 lazy" :data-src="tyreImage"/>
            </Link>
        </div>

        <!--        <Link class="w-full" :href="route('brands.show', product.brand)" v-if="product.brand">-->
        <!--            &lt;!&ndash;            <img class="max-h-8 max-w-fit mb-2 lazy object-cover" :data-src="product.brand.image"/>&ndash;&gt;-->
        <!--            <div class="w-full h-8 mb-2 bg-cover bg-no-repeat lazy bg-center max-w-[150px] mx-auto"-->
        <!--                 :style="{'background-image': 'url(' + product.brand.image + ')'}"></div>-->
        <!--        </Link>-->

        <BrandImage v-if="product.brand"
                    :brand="product.brand"
                    class="mb-2"
                    no-shadow
                    no-background
        ></BrandImage>

        <p class="text-dark mb-2 px-4 text-center min-h-content flex-grow flex items-center">
            <template v-if="product.brand">{{ product.brand.name }}</template>
            {{ product.name }}
        </p>

        <ReviewStarRating class="mt-2"
                          :modelValue="product.reviews_avg_rating"
                          size="1x"
                          spacing="space-x-2"></ReviewStarRating>

        <AppButton class="mt-2 whitespace-nowrap" :href="reviewsLink">
            Read Reviews
        </AppButton>

        <slot name="footer"></slot>

        <p class="my-2 text-sm text-center">{{ product.reviews_count ?? 0 }} reviews</p>
    </AppCard>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3";
import ReviewStarRating from "@/Components/Reviews/ReviewStarRating";
import AppButton from "@/Components/AppButton";
import AppCard from "@/Components/AppCard";
import LazyLoad from "vanilla-lazyload";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import BrandImage from "@/Components/Brands/BrandImage.vue";

export default {
    components: {AppCard, AppButton, ReviewStarRating, LazyLoad, FontAwesomeIcon, Link, BrandImage},
    props: {
        product: Object,
        badge: Object
    },
    computed: {
        reviewsLink() {
            return this.route("products.show", this.product);
        },
        tyreImage() {
            return this.product.image ?? "/images/misc/default_tyre.jpeg";
        }
    },
    mounted()
    {
        var lazyLoadInstance = new LazyLoad({});
    }
};
</script>

<style scoped>

</style>
